// extracted by mini-css-extract-plugin
export default {"autoplay":"nf_ng","autoplay__button":"nf_nh","autoplay_controls":"nf_ni","autoplay__limits":"nf_nj","autoplay__bet_error":"nf_nk","error":"nf_nl"};